/* eslint no-unused-vars: 'off' */
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { getCurrentCourse } from '@/api/course';
import { getStudentDm } from '@/api/dm';
import { getServeStatus } from '@/api';
import Button from '@/components/button';
import Guide from '@/components/guide';
import Message from '@/components/message/message';
import MobileMessage from '@/components/message/mobile-message';
import MobileSend from '@/components/send/mobile-send';
import Send from '@/components/send/send';
import { CDN_BASE_URL } from '@/constants';
import * as Event from '@/event/message_events';
import { ApiUri, request } from '@/helper';
import { getToken } from '@/lib/fetch';
import audio from '@/utils/audio';

import './dialog.scss';
import './mobile-dialogue.scss';

export default class XiguaDialog extends React.Component {
  static propTypes = {
    $closeDialog: PropTypes.func,
    $updateMessage: PropTypes.func,
    data: PropTypes.object,
    methods: PropTypes.object,
    opening: PropTypes.bool,
    loading: PropTypes.bool,
    fnExtends: PropTypes.func,
    extraMessage: PropTypes.object,
    toggleDialog: PropTypes.func,
    showExtraMessage: PropTypes.func,
    clearExtraMessage: PropTypes.func,
    marvin: PropTypes.object,
  };

  /**
   * @typedef ServeStatus
   * @property {string=} startDate
   * @property {Array<Array<string>> =} timeLine
   * @property {boolean} nowIsAtService
   */

  constructor(props) {
    super(props);
    this.state = {
      showQuestionTime: true,
      audioSrc: null,
      // 打开次数
      openCount: 0,
      /** @type ServeStatus */
      serveStatus: { nowIsAtService: true },
      // 这是一个 DM 单的二维码链接地址, 存在值则表示当前学生没有购买课程
      DMQRCode: undefined,
    };
    this.audioRef = React.createRef();
    // this.firstOpen = false;
    // this.isFirstOpenDialog = this.isFirstOpenDialog.bind(this);
  }

  componentDidMount() {
    Event.bus.on(Event.PLAYFINISH, () => {
      const audioDom = this.audioRef.current;
      if (audioDom) {
        audioDom.pause();
        audioDom.currentTime = 0;
      }
    });
    Event.bus.on(Event.PLAY, (newAudioSrc) => {
      const audioDom = this.audioRef.current;
      const { audioSrc } = this.state;
      if (!this.hasListenEnded) {
        audioDom.addEventListener('ended', () => {
          Event.bus.emit(Event.PLAYFINISH, null);
        });
        this.hasListenEnded = true;
      }
      if (newAudioSrc === audioSrc) {
        if (audioDom.paused) {
          audioDom.play();
        } else {
          audioDom.pause();
          audioDom.currentTime = 0;
          Event.bus.emit(Event.PLAYFINISH, null);
        }
      } else {
        Event.bus.emit(Event.PLAYFINISH, newAudioSrc);
        this.setState({
          audioSrc: newAudioSrc,
        }, () => {
          audioDom.play();
        });
      }
    });
    this.queryServeTime().then();
    this.setQueryTimer();
    this.handleFinishedGuide();

    this.initializeDMQRCode().then();
  }

  componentDidUpdate(prevProps, prevState) {
    const { opening } = this.props;
    if (prevProps.opening === opening) {
      return;
    }
    if (opening) {
      // this.isFirstOpenDialog();
      const { openCount } = this.state;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showQuestionTime: true, openCount: openCount + 1 });
      this.timer = setTimeout(() => {
        this.setState({ showQuestionTime: false });
      }, 4000);
      const imSendQuestion = window.sessionStorage.getItem('im_send_question');
      if (imSendQuestion) return;
      this.imTimer = setTimeout(() => {
        this.sendQuestion();
      }, 1000);
    } else {
      clearTimeout(this.timer);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.imTimer);
    clearTimeout(this.serveQueryTimer);
  }

  render() {
    const {
      data,
      methods,
      opening,
      loading,
      fnExtends,
      extraMessage,
      toggleDialog,
      showExtraMessage,
      clearExtraMessage,
      marvin,
    } = this.props;
    const { audioSrc, openCount, serveStatus, hasShowedGuide, DMQRCode } = this.state;

    let name = '';
    if (opening !== null) {
      name = opening ? 'fade-show' : 'fade-hide';
    }

    if (DMQRCode) {
      return (
        <div className={`dl-wrapper ${name} ${openCount > 0 ? '' : 'hide'}`}>
          <div className="dl-header">
            <div className="dl-header-teacher">
              <section
                className="dl-header-avatar"
                style={{
                  backgroundImage: `url(${CDN_BASE_URL}/bro-ba.png)`,
                  height: 52,
                }}
              />
              <section className="dl-header-content">
                <header>西瓜老师</header>
                <article>报名系统课，遇到问题可以问老师哦</article>
              </section>
            </div>
            <div className="dl-header-close" onClick={() => this.closeDialog()} />
          </div>
          <div className="dl-dm-qrcode-wrapper">
            <img className="dl-dm-qrcode" src={DMQRCode} alt={DMQRCode} />
            <div className="dl-dm-slogan">微信扫码解锁试听课</div>
            <Button size="l" theme="purple" onClick={() => window.location.reload()}>已报名</Button>
          </div>
        </div>
      );
    }

    if (!hasShowedGuide) {
      return <Guide onFinished={this.handleFinishedGuide} hasShowed={hasShowedGuide} opening={opening} />;
    }

    let messages = data && data.messages ? data.messages : [];
    if (extraMessage) {
      messages = messages.concat(extraMessage);
    }

    if (data.isMobile) {
      return (
        <div id="dl-wrapper" className={`dl-wrapper ${name} ${openCount > 0 ? '' : 'hide'}`}>
          <audio src={audioSrc} ref={this.audioRef} />
          <div className={((data && data.online) || !this.state.showQuestionTime)
            ? 'dl-online-time hide' : 'dl-online-time'}
          >
            <p>在线答疑时间</p>
            <p>工作日：17:00-22:00</p>
            <p>周   末  ： 10:00-22:00</p>
          </div>
          <MobileMessage
            data={data}
            audioSrc={audioSrc}
            resize={data && data.resize}
            messages={messages}
            online={data && data.online}
            isMobile={data.isMobile}
            $updateMessage={this.$updateMessage}
          />
          <MobileSend data={data} methods={methods} $updateMessage={this.$updateMessage} />

          <div className="dialogue-btn" onClick={() => this.closeDialog()}>
            <img src="https://m.xiguacity.cn/xigua-im/im_test/im-slide-icon.png" alt="滑动" />
          </div>
          <div className={`im-modal-bg ${loading ? 'show' : ''}`}>
            <div className="im-loading-content">
              <div className="loading-icon" />
              <div className="im-loading-div">
                <div id="im-loading" className="im-loading-title">加载中...</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const startDate = serveStatus && dayjs(serveStatus.startDate).format('YYYY-MM-DD');

    const marvinName = marvin && marvin.name ? '西瓜老师' : '';
    const showMarvinAvatar = marvin && marvin.avatar;
    const marvinAvatar = showMarvinAvatar || `${CDN_BASE_URL}/im-teacher-online.png`;

    return (
      <div className={`dl-wrapper ${name} ${openCount > 0 ? '' : 'hide'}`}>
        <div className={`dl-header ${!serveStatus.nowIsAtService ? 'dl-header-out-of-serve' : ''}`}>
          <div className="dl-header-teacher">
            <section
              className="dl-header-avatar"
              style={{
                backgroundImage:
                  serveStatus.nowIsAtService ? `url(${marvinAvatar})` : `url(${CDN_BASE_URL}/bro-ba.png)`,
                height: serveStatus.nowIsAtService ? 46 : 52,
              }}
            >
              {serveStatus.nowIsAtService && showMarvinAvatar && !DMQRCode && (<div className="dl-header-online" />)}
            </section>
            <section className="dl-header-content">
              <header>{serveStatus.nowIsAtService ? marvinName : '机器人助理' }</header>
              <article>
                {serveStatus.nowIsAtService ? (
                  <p>当前在线，遇到问题可以问老师哦</p>
                ) : (
                  <>
                    <p>亲爱的小西瓜，现在是休息时间哦，我是机器 人助理，我会记录你的问题并留言给老师。</p>
                    <p className="dl-header-serve-times">
                      老师回答时间
                      <span>{serveStatus.timeLine.map((item) => `【${startDate} ${item.join('-')}】`)}</span>
                    </p>
                  </>
                )}
              </article>
            </section>
          </div>
          <div className="dl-header-close" onClick={() => this.closeDialog()} />
        </div>
        <Message
          isMobile={data && data.isMobile}
          messages={messages}
          online={data && data.online}
          $updateMessage={this.$updateMessage}
          data={data}
          methods={methods}
        />
        <Send
          fnExtends={fnExtends}
          data={data}
          methods={methods}
          $updateMessage={this.$updateMessage}
          toggleDialog={toggleDialog}
          showExtraMessage={showExtraMessage}
          clearExtraMessage={clearExtraMessage}
        />
      </div>
    );
  }

  $updateMessage = (message) => {
    this.props.$updateMessage(message);
  }

  /**
   * 初始化 DM 链接
   * @return {Promise<void>}
   */
  initializeDMQRCode = async () => {
    try {
      const currentCourse = await getCurrentCourse();
      if (
        currentCourse
        // 预调期
        && !currentCourse.isPreTransferred
        // 退课 或者 没有系统课
        && (currentCourse.isDropout || !currentCourse.coursesCount)
      ) {
        // 获取二维码
        const dmRes = await getStudentDm();
        if (dmRes && dmRes.url) {
          this.setState({
            DMQRCode: dmRes.url,
          });
        }
      } else {
        this.setState({
          DMQRCode: undefined,
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('获取当前学生课程失败:', e);
    }
  };

  handleFinishedGuide = () => {
    this.setState({ hasShowedGuide: !window.XiguaElectronBridge || !!window.localStorage.getItem('hasViewedImGuide') });
  }

  queryServeTime = async () => {
    const serveStatus = await getServeStatus();
    this.setState({
      serveStatus,
    });
  }

  setQueryTimer = () => {
    this.serveQueryTimer = setTimeout(async () => {
      await this.queryServeTime();
    }, 10000);
  }

  // 关闭对话框
  closeDialog() {
    this.props.$closeDialog();
    Event.bus.emit(Event.CLOSE);
    audio.stop();
  }

  // 发送本课问题
  sendQuestion() {
    const { data, methods } = this.props;
    // 不能发送本课问题
    if (!(data && data.canSendQuestion)) return;
    const cb = methods && methods.sendQuestion;
    request({
      url: ApiUri.OBTAIN_PROBLEMS,
      method: 'post',
      data: { lectureOid: data && data.lectureId },
      headers: {
        token: getToken(),
        'x-csrf-token': data && data.csrf,
      },
    }).then((/** @type {{ status: number, body: string }} */ res) => {
      if (res.status === 200) {
        window.sessionStorage.setItem('im_send_question', 'true');
        this.$updateMessage(res.body);
        cb && cb.apply(null, ['success', this.$updateMessage]);
      } else {
        cb && cb.apply(null, ['error', this.$updateMessage]);
      }
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.error('获取本课问题error:', err);
    });
  }
}
